import { render } from "./GoTopButton.vue?vue&type=template&id=a403a8fa"
import script from "./GoTopButton.vue?vue&type=script&lang=js"
export * from "./GoTopButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__